export default class Dialog {
    constructor(props = {}) {
        if (props.hasOwnProperty('containerElement')) {
            this.containerElement = props.containerElement;
        }
        else {
            throw new Error('containerElement is not set');
        }
        if (props.hasOwnProperty('dialogElement')) {
            this.dialogElement = props.dialogElement;
        }
        else {
            throw new Error('dialogElement is not set');
        }
        if (props.hasOwnProperty('btnOpenElement')) {
            this.btnOpenElement = props.btnOpenElement;
        } else {
            //throw new Error('btnOpenElement is not set');
        }
        if (props.hasOwnProperty('btnCloseElement')) {
            this.btnCloseElement = props.btnCloseElement;
        } else {
            throw new Error('btnCloseElement is not set');
        }
        if (this.dialogElement.classList.contains('login--inline')) {
            this.removeTabIndex();
            return;
        }
        else if (this.dialogElement.classList.contains('dialog--inline')) {
            this.open = this.open.bind(this);
            this.close = this.close.bind(this);
        }
        else {
            this.dialogElement.inert = true;
            this.previousActiveElement = undefined;
            this.isModal = true;
            this.trapFocus = this.trapFocus.bind(this);

            this.open = this.open.bind(this);
            this.close = this.close.bind(this);
        }


        this.addEventListeners();
    }

    getFocusableElements() {
        const selector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
        return Array.from(this.dialogElement.querySelectorAll(selector))
            .filter((el) => el.offsetParent !== null && !el.hasAttribute('inert'));
    }

    trapFocus(e) {
        if (e.key !== 'Tab') return;
        const focusable = this.getFocusableElements();
        if (focusable.length === 0) {
            e.preventDefault();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;
        const insideDialog = this.dialogElement.contains(active);

        if (e.shiftKey) {
            if (!insideDialog || active === first) {
                last.focus();
                e.preventDefault();
            }
        } else {
            if (!insideDialog || active === last) {
                first.focus();
                e.preventDefault();
            }
        }
    }

    removeTabIndex() {
        Array.from(this.dialogElement.querySelectorAll('input,button'), x => x.removeAttribute('tabindex'));
    }

    addEventListeners() {
        if (this.btnOpenElement) {
            [].forEach.call(this.btnOpenElement, (button) => {
                button.addEventListener('click', this.open);
            });
        }
        if (this.btnCloseElement) {
            this.btnCloseElement.addEventListener('click', this.close);
        }

        const KEYCODES = {
            ESC: 27
        };

        window.addEventListener('keydown', (e) => {
            switch (e.keyCode) {
                case KEYCODES.ESC:
                    this.close(e);
                    break;
            }

        });
        this.containerElement.addEventListener('click', (e) => {
            if (e.target.classList.contains('dialog')) {
                this.close(e);
            }
        });
    }

    open(e) {
        if (e) {
            e.preventDefault();
            this.previousActiveElement = e.target;
        }

        this.containerElement.classList.add('dialog--open');
        this.dialogElement.classList.add('login--open');

        if (!this.dialogElement.classList.contains('dialog--inline')) {
            this.dialogElement.inert = false;
            document.querySelector('.page').inert = true;
            document.body.style.position = 'relative';
        }

        if (this.isModal) {
            document.addEventListener('keydown', this.trapFocus);
        }

        setTimeout(() => {
            this.btnCloseElement.focus({
                preventScroll: true
            });
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }, 0);
    }

    close(e) {
        e.preventDefault();

        if (!this.containerElement.classList.contains('dialog--open')) return;

        this.containerElement.classList.remove('dialog--open');
        this.dialogElement.classList.remove('login--open');

        if (!this.dialogElement.classList.contains('dialog--inline')) {
            document.querySelector('.page').inert = false;
            this.dialogElement.inert = true;
            document.body.style.position = 'static';
        }

        if (this.isModal) {
            document.removeEventListener('keydown', this.trapFocus);
        }

        if (this.previousActiveElement) {
            this.previousActiveElement.focus();
        }

        dispatchEvent(new Event('dialog-closed'));
    }
}